import { useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import { FaCheck, FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { FaDownLong, FaXmark } from "react-icons/fa6";
import { getData, postData } from "../../api/ApiRest";

function Roles() {
    const [rolCompanyCrud, setRolCompanyCrud] = useState({ ModalVisible: false, Descripcion: '', Activo: true, Titulo: '', Rollid: '' });
    const [rollPermiso, setRollPermiso] = useState([]);
    const [permisoAnterior, setPermisoAnterior] = useState(0);
    const [historialPermiso, setHistorialPermiso] = useState([]);
    const [rollPermisoGlobal, setPermisoGlobal] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        rolesCreados();

        if (rolCompanyCrud.ModalVisible) {
            setHistorialPermiso([]);  // limpiamos siempre al abrir
            setPermisoAnterior(0);
        }
    }, [rolCompanyCrud.ModalVisible]);

    const rolesCreados = () => {
        setLoading(true);

        getData('api/Usuario/getRollCreadosEmpresa', {
            compnayId: 9999,
            usuarioid: ''
        }, false).then(response => {
            setPermisoGlobal(response.permisos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para guardar un nuevo rol y de paso traerme la información correspondiente a los permisos
    ///Diego F Sandoval F
    ///21-08-2025
    const rolSave = () => {
        if (rolCompanyCrud.Descripcion === '') {
            alert('Por favor ingresa una descripción');
            return;
        }

        ///Buscamos todos los permisos que se modificaron para actualizarlos en BD
        let rolesActivos = rollPermiso || {};

        setLoading(true);

        postData('api/Usuario/guardarRol', {
            CompanyId: 9999,
            Descripcion: rolCompanyCrud.Descripcion,
            Activo: rolCompanyCrud.Activo,
            Rollid: rolCompanyCrud.Rollid || ''
        }, rolesActivos, false).then(response => {
            if (!response.edit) { ///Si es distinto de edit es porque es un create
                setRollPermiso(response.permisos);

                alert('Agregado con éxito');
            } else {
                alert('Modificado con éxito');
            }

            setLoading(false);
        }, error => {
            console.log(error);

            setLoading(false);
        })
    }

    ///Función para ver permisos hijos de acuerdo a un padre
    ///Diego F Sandoval F
    ///21-08-2025
    const verPermisos = (rollpadreid, rollid) => {
        // Guardamos array solo si hay permisos actuales
        if (rollPermiso && rollPermiso.length > 0) {
            setHistorialPermiso(prev => [...prev, { permisoAnterior, rollPermiso }]);
        }

        setRollPermiso([]);

        setLoading(true);

        getData('api/Usuario/getRollGlobalDetallado', {
            rollpadreid: rollpadreid,
            rollid: rollid,
            CompanyId: ''
        }, false).then(response => {
            setRollPermiso(response.rollDetallado);
            setPermisoAnterior(prev => prev + 1); ////Como ya asignamos los nuevos permisos, sumamos en uno el nivel

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para poder regresar entre menús de los roles
    const regresarMenuRoles = () => {
        if (historialPermiso.length > 0) {
            setLoading(true);

            const anterior = historialPermiso[historialPermiso.length - 1];
            setRollPermiso(anterior.rollPermiso || []);
            setPermisoAnterior(anterior.permisoAnterior ?? 0);
            setHistorialPermiso(prev => prev.slice(0, -1));

            setLoading(false);
        } else {
            // No hay historial, entonces sí cerramos
            setRolCompanyCrud(prev => ({ ...prev, ModalVisible: false }));
            setRollPermiso([]);
            setPermisoAnterior(0);
            setHistorialPermiso([]);
            rolesCreados();
        }
    }

    ///Función para eliminar un rol global
    const eliminarRoll = (Rollid) => {
        setLoading(true);

        getData('api/Usuario/eliminarRolGlobal', {
            Rollid: Rollid
        }, false).then(response => {
            if (response.status) {
                alert('Rol eliminado con éxito');
                setRollPermiso(prev => prev.filter(rol => rol.rollid !== Rollid));

                rolesCreados();
            } else {
                alert('Los siguientes usuarios cuentan con este permiso: ' + response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Seguridad</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Roles</Breadcrumb.Item>
        </Breadcrumb>

        <Button variant='success'
            onClick={() => setRolCompanyCrud({
                ...rolCompanyCrud, ModalVisible: true,
                Titulo: 'Nuevo rol', Descripcion: '', Activo: true, Rollid: ''
            })}
            className='mb-2'>
            <FaPlus size={'1rem'} />
        </Button>

        {<LoadingComponent Loading={loading} />}
        <div className='table-responsive mt-2'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            Descripción
                        </th>
                        <th>
                            Activo
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rollPermisoGlobal.map((item, index) => (
                        <tr key={item.rollid}>
                            <td className='text-center'>
                                <Button type='button' variant='primary' size='sm' title='Editar rol' className="me-2"
                                    onClick={() => {
                                        setRolCompanyCrud({
                                            ...rolCompanyCrud, ModalVisible: true,
                                            Titulo: 'Editar rol', Descripcion: item.descripcion, Activo: item.activo,
                                            Rollid: item.rollid
                                        });

                                        // Guardamos punto de inicio
                                        setHistorialPermiso([{ permisoAnterior: 0, rollPermiso: [] }]);

                                        verPermisos('', item.rollid);
                                    }}>
                                    <FaEdit size={'1rem'} />
                                </Button>
                                <Button type='button' variant='danger' size='sm' title='Eliminar rol'
                                    onClick={() => {
                                        eliminarRoll(item.rollid)
                                    }}>
                                    <FaTrash size={'1rem'} />
                                </Button>
                            </td>
                            <td className='text-center'>
                                {item.descripcion}
                            </td>
                            <td className='text-center'>
                                {item.activo ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        <Modal
            show={rolCompanyCrud.ModalVisible}
            size='xl'
            onHide={() => {
                setRolCompanyCrud({ ...rolCompanyCrud, ModalVisible: false })
                setRollPermiso([]);
                setPermisoAnterior(0);
                setHistorialPermiso([]);

                ///Buscamos los roles nuevamente al cerrar el modal, esto para evitar refrescar la pagina
                rolesCreados();
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{rolCompanyCrud.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-9'>
                        <FloatingLabel controlId="rolNuevoInput" label="Descripción">
                            <Form.Control
                                as="input"
                                placeholder="Ingresa el nombre del rol"
                                rows={1}
                                value={rolCompanyCrud.Descripcion}
                                onChange={event => setRolCompanyCrud({ ...rolCompanyCrud, Descripcion: event.target.value })}
                                autoComplete='off'
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <Form.Check
                            required
                            label="Activo"
                            defaultChecked={true}
                            onChange={event => setRolCompanyCrud({ ...rolCompanyCrud, Activo: event.target.checked })}
                        />
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={rolSave}>Guardar</Button>
                    </div>
                </div>
                <br />
                <div className='row'>
                    <div className='table-responsive mt-2'>
                        <table className='table table-sm table-bordered table-hover'>
                            <thead>
                                <tr>
                                    <th>
                                        Titulo
                                    </th>
                                    <th>
                                        Descripción
                                    </th>
                                    <th>
                                        Activo
                                    </th>
                                    <th>

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rollPermiso.map((item, index) => (
                                    <tr key={item.rollpermisoid}>
                                        <td className='text-left'>
                                            {item.titulo}
                                        </td>
                                        <td className='text-left'>
                                            {item.descripcion}
                                        </td>
                                        <td className='text-center'>
                                            <Form.Check
                                                checked={item.activo}
                                                onChange={event => setRollPermiso(
                                                    rollPermiso.map(p => p.rollpermisoid === item.rollpermisoid ?
                                                        { ...p, activo: event.target.checked } : p
                                                    )
                                                )} />
                                        </td>
                                        <td className='text-center'>
                                            {item.cantidadPermisos > 0 ?
                                                <Button variant="primary" size='sm' type='button' onClick={() => verPermisos(item.permisoid, item.rollid)}>
                                                    <FaDownLong size={'1rem'} />
                                                </Button>
                                                : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <br />

                        <div className='row'>
                            <div className='col-md-1'>
                                <Button variant="success" size='sm' type='button' onClick={rolSave}>Guardar</Button>
                            </div>
                            <div className='col-md-1'>
                                <Button variant="warning" size='sm' type='button' onClick={regresarMenuRoles}>Cancelar</Button>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal.Body>

        </Modal>

    </div>

}

export default Roles;